import { Adm } from './../_models/adm';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Injectable } from '@angular/core';
import { User } from '../_models/user';
import { Observable } from 'rxjs';

@Injectable()
export class UsersService {

    private usersCollection: AngularFirestoreCollection<User>;

    constructor(
        private _firestore: AngularFirestore
    ) { }

    getUserByEmail(email: string): Observable<any[]> {

        this.usersCollection = this._firestore.collection<any>('users', ref =>
            ref
                .where('email', '==', email)
        );

        return this.usersCollection.snapshotChanges().map(o => {
            return o.map(item => {
                const data = item.payload.doc.data();
                const uuid = item.payload.doc.id;

                return new Object({ ...{ uuid: uuid }, ...data });
            });
        });

    }

    getUserById(uuid: string) {
        return this._firestore.doc<User>('users/' + uuid).snapshotChanges().map(userObj => {
            const data = userObj.payload.data();
            const id = userObj.payload.id;
            return new User({ ...{ uuid: id }, ...data });
        });
    }

    getGuardians(): Observable<any[]> {

        this.usersCollection = this._firestore.collection<any>('users', ref =>
            ref
                .where('right.key', '==', 'gdn')
        );

        return this.usersCollection.snapshotChanges().map(o => {
            return o.map(item => {
                const data = item.payload.doc.data();
                const uuid = item.payload.doc.id;

                return new Object({ ...{ uuid: uuid }, ...data });
            });
        });

    }

    insertAdm(adm: Adm) {
        return this._firestore
            .collection('admins')
            .add(adm.toFirebase());
    }
}
